import React, { useState, useEffect, useCallback } from 'react';
import adminService from '../services/adminService';
import { useToast } from '../hooks/use-toast';
import ContactFilterBar from './ContactFilterBar';
import ContactRow from './ContactRow';

const AdminContacts = () => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');
  const { toast } = useToast();

  const loadContacts = useCallback(async () => {
    try {
      const statusFilter = filter === 'all' ? null : filter;
      const response = await adminService.getContacts(statusFilter);
      setContacts(response.data.contacts);
    } catch (error) {
      toast({ title: 'Error', description: 'Failed to load contacts', variant: 'destructive' });
    } finally {
      setLoading(false);
    }
  }, [filter, toast]);

  useEffect(() => {
    loadContacts();
  }, [loadContacts]);

  const updateStatus = async (contactId, newStatus) => {
    try {
      await adminService.updateContactStatus(contactId, newStatus);
      toast({ title: 'Success', description: 'Contact status updated' });
      loadContacts();
    } catch (error) {
      toast({ title: 'Error', description: 'Failed to update status', variant: 'destructive' });
    }
  };

  return (
    <div>
      <div className="mb-8 flex items-center justify-between">
        <div>
          <h2 className="text-3xl font-bold text-gray-900">Contacts</h2>
          <p className="text-gray-600 mt-2">Manage contact form submissions</p>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-6">
        <ContactFilterBar filter={filter} onFilterChange={setFilter} />

        <div className="overflow-x-auto">
          <table className="w-full" data-testid="contacts-table">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Contact</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Company</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Message</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {loading ? (
                <tr>
                  <td colSpan="6" className="px-6 py-4 text-center text-gray-500">Loading...</td>
                </tr>
              ) : contacts.length === 0 ? (
                <tr>
                  <td colSpan="6" className="px-6 py-4 text-center text-gray-500">No contacts found</td>
                </tr>
              ) : (
                contacts.map((contact) => (
                  <ContactRow key={contact.id} contact={contact} onStatusChange={updateStatus} />
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminContacts;
